import {AppSettings} from './index';

const generateNewReport = '/idar/user_prepaid';
const signIn = '/userservice/nopass/alberto/new';
const userInfo = '/idaw-service/userinfo';
const saveMarketingUserData = '/idar-service/person';
const saveProfile = uniqueId => `/nodeservice/tenant/${AppSettings.tenant}/node/${uniqueId}/update`;
const fetchProfile = uniqueId => `/nodeservice/tenant/${AppSettings.tenant}/node/${uniqueId}`;
const reportList = (start, size = AppSettings.paginationSize) => `/searchservice/tenant/${AppSettings.tenant}/type/${AppSettings.documentType}/from/${start}/size/${size}/sort/inserted_at:desc`;
const reportEventStream = (username = 'aliuska.lopez@dox.cl') => `/idar/sse/report/events?username=${username}`;
const reportPreview = uniqueId => `/nodeservice/preview/tenant/${AppSettings.tenant}/node/${uniqueId}`;
const reportDownload = uniqueId => `/nodeservice/download/tenant/${AppSettings.tenant}/node/${uniqueId}`;
const deniedRequest = uniqueId => `/idar/cancel_request/${uniqueId}`;
const signOut = '/userservice/logout';
const getOffersEndPoint = '/idar/get_active_promotions';
const saveRequestEndPoint = '/idar/save_user_prepaid';
const getRequestEndPoint = (id) => '/idar/get_user_prepaid?uuid=' + id;
const sendContactInfo = '/idar/send_email_agreement';
const faq = '/idaw-service/get_tenant/idar'
const getNodeExtraInfo = '/idaw-service/get_tenant/idai';
const previewInvoice = (id, token) => `/idar/get_comprobante_pago/${id}?ticket=${token}`;

export default {
  generateNewReport,
  signIn,
  userInfo,
  saveProfile,
  fetchProfile,
  saveMarketingUserData,
  signOut,
  reportPreview,
  reportDownload,
  reportEventStream,
  reportList,
  deniedRequest,
  getOffersEndPoint,
  saveRequestEndPoint,
  getRequestEndPoint,
  sendContactInfo,
  faq,
  getNodeExtraInfo,
  previewInvoice
};
